module.exports = __webpack_public_path__ + "img/Cassette_Replacement.afc48bb8.png";